import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faFileAlt,
  faPeopleGroup,
  faContactBook,
  faUtensils,
} from "@fortawesome/free-solid-svg-icons";
import { useAdminContext } from "../../context/AdminContext";
import "./Nav.css";
import { useEffect, useState } from "react";

const Nav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchBlogs, fetchRecipes } = useAdminContext();

  const [blogCount, setBlogCount] = useState(0);
  const [recipeCount, setRecipeCount] = useState(0);

  useEffect(() => {
    const loadCounts = async () => {
      try {
        const blogs = await fetchBlogs();
        const recipes = await fetchRecipes();
        setBlogCount(blogs.length);
        setRecipeCount(recipes.length);
      } catch (err) {
        console.error("Failed to fetch counts", err);
      }
    };

    loadCounts();
  }, [fetchBlogs, fetchRecipes]);

  const navItems = [
    { name: "Dashboard", path: "/admin/dashboard", icon: faHome },
    { name: "Blogs", path: "/admin/blog", icon: faFileAlt, count: blogCount },
    { name: "Recipe", path: "/admin/manage-recipe", icon: faUtensils, count: recipeCount },
    { name: "Users", path: "/admin/manage-users", icon: faPeopleGroup },
    { name: "Messages", path: "/admin/manage-contacts", icon: faContactBook },
  ];

  return (
    <aside className="admin-sidebar">
      <div className="admin-sidebar-header">
        <h2>Admin</h2>
      </div>
      <ul className="admin-nav-list">
        {navItems.map((item) => (
          <li
            key={item.path}
            className={`admin-nav-item ${location.pathname === item.path ? "active" : ""}`}
          >
            <button onClick={() => navigate(item.path)} className="admin-nav-link">
              <FontAwesomeIcon icon={item.icon} className="admin-nav-icon" />
              <span className="nav-text">
                {item.name}
                {item.count !== undefined && (
                  <span className="nav-badge">{item.count}</span>
                )}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default Nav;
